/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { metaLocationSearchCountries } from '../../axios/metaLocationSearchCountries'
import type {
	MetaLocationSearchCountriesError,
	MetaLocationSearchCountriesQueryParams,
	MetaLocationSearchCountriesResponse,
} from '../../types/MetaLocationSearchCountries'

export const metaLocationSearchCountriesQueryKey = (params?: MetaLocationSearchCountriesQueryParams) =>
	[{ url: '/meta/countries' }, ...(params ? [params] : [])] as const

export type MetaLocationSearchCountriesQueryKey = ReturnType<typeof metaLocationSearchCountriesQueryKey>

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaLocationController.php MetaLocationController::searchCountries */
export function metaLocationSearchCountriesQueryOptions(
	params?: MetaLocationSearchCountriesQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		MetaLocationSearchCountriesResponse,
		AxiosError<MetaLocationSearchCountriesError>,
		MetaLocationSearchCountriesResponse,
		MetaLocationSearchCountriesQueryKey
	>({
		queryKey: metaLocationSearchCountriesQueryKey(params),
		queryFn: ({ signal }) => metaLocationSearchCountries(params, { signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaLocationController.php MetaLocationController::searchCountries */
export function useMetaLocationSearchCountries<TSelectData = MetaLocationSearchCountriesResponse>(
	params?: MetaLocationSearchCountriesQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					MetaLocationSearchCountriesResponse,
					AxiosError<MetaLocationSearchCountriesError>,
					TSelectData,
					MetaLocationSearchCountriesQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<MetaLocationSearchCountriesError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...metaLocationSearchCountriesQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaLocationController.php MetaLocationController::searchCountries */
export function useMetaLocationSearchCountriesSuspense<TSelectData = MetaLocationSearchCountriesResponse>(
	params?: MetaLocationSearchCountriesQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					MetaLocationSearchCountriesResponse,
					AxiosError<MetaLocationSearchCountriesError>,
					TSelectData,
					MetaLocationSearchCountriesQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<MetaLocationSearchCountriesError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...metaLocationSearchCountriesQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
